import request from '@/utils/request'
import qs from 'qs'
export function getSupplier(params) {
  return request({
    url: 'api/yumiSupplier'+'?' + qs.stringify(params, { indices: false }),
    method: 'get'
  })
}
export function getSupplierIndexData() {
  return request({
    url: 'api/supplierIndexData',
    method: 'get'
  })
}
export function getSupplierTableData(params){
	
	return request({
	  url: 'api/yumiOrderSupplier'+'?' + qs.stringify(params, { indices: false }),
	  method: 'get'
	})
	
	
}
export function edit(data) {
  return request({
    url: 'api/yumiSupplier',
    method: 'put',
    data
  })
}

export function downloadContactApi(data) {
  return request({
    url: 'api/getContactPdf',
    method: 'post',
    data
  })
}


export function querySupplier(params){
	
	return request({
	  url: 'api/queryYumiSupplierPage'+'?' + qs.stringify(params, {strictNullHandling: true }),
	  method: 'get'
	})
	
}